import { render, staticRenderFns } from "./cargoUserSelect.vue?vue&type=template&id=5ca72dc1&"
import script from "./cargoUserSelect.vue?vue&type=script&lang=js&"
export * from "./cargoUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca72dc1')) {
      api.createRecord('5ca72dc1', component.options)
    } else {
      api.reload('5ca72dc1', component.options)
    }
    module.hot.accept("./cargoUserSelect.vue?vue&type=template&id=5ca72dc1&", function () {
      api.rerender('5ca72dc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standard/cargoUserSelect.vue"
export default component.exports